import DOMPurify from 'dompurify';

/**
 * Utility function to purify any input from HTML/XSS injections
 * @param input The DOM input/innerHTML which needs to be purified
 */
export function purifyHTML(input: string, isOriginalSrcNeeded: boolean = false) {
    const ATTR_LIST = ['target', 'onload'];
    if (isOriginalSrcNeeded) {
        ATTR_LIST.push('originalSrc');
    }
    if (DOMPurify?.sanitize) {
        return DOMPurify.sanitize(input, {
            ADD_ATTR: ATTR_LIST,
            RETURN_TRUSTED_TYPE: true,
        });
    }
    return input;
}
